/*** JQuery Passive Event Listeners ***/

jQuery.event.special.touchstart = {
	setup: function( _, ns, handle ) {
		this.addEventListener("click touchstart", handle, { passive: !ns.includes("noPreventDefault") });
	}
};
jQuery.event.special.touchmove = {
	setup: function( _, ns, handle ) {
		this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
	}
};
jQuery.event.special.wheel = {
	setup: function( _, ns, handle ){
		this.addEventListener("wheel", handle, { passive: true });
	}
};
jQuery.event.special.mousewheel = {
	setup: function( _, ns, handle ){
		this.addEventListener("mousewheel", handle, { passive: true });
	}
};

/*** Smooth Scroll ***/

$('a[href*="#"]')
	// Remove links that don't actually link to anything
	.not('[href="#"]')
	.not('[href="#0"]')
	.not('[href="#platform-product"]')
	.click(function (event) {
		// On-page links
		if (
			location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
			&&
			location.hostname == this.hostname
		) {
			// Figure out element to scroll to
			let target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			// Does a scroll target exist?
			if (target.length) {
				// Only prevent default if animation is actually gonna happen
				event.preventDefault();
				if ($(window).width() >= 1024) {
					$('html, body').animate({
						scrollTop: target.offset().top - 100
					}, 1000);
				} else {
					$('html, body').animate({
						scrollTop: target.offset().top - 80
					}, 1000);
				}
			}
		}
	});


/*** IE Custom Object Fit ***/

var userAgent, ieReg, ie;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie = ieReg.test(userAgent);

if (ie) {
	$("body").addClass("is-ie");
	$(".full-image-container").each(function () {
		var $container = $(this),
			imgUrl = $container.find("img").prop("src");
		if (imgUrl) {
			$container.css("backgroundImage", 'url(' + imgUrl + ')').addClass("custom-object-fit");
		}
	});
}

/*** Safari ***/

var safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if (safari) {
	$('body').addClass('is-safari');
}

/*** Navigation ***/

toggle = $(".js-menu-toggle");
menu = $(".js-menu");
header = $(".header");
collapse = $(".menu-item-has-children");
searchToggle = $(".js-search-toggle");
ctaToggle = $(".js-cta-toggle");
topicsToggle = $(".js-topics-toggle");
partnersSearchToggle = $(".js-partners-search-toggle");
userToggle = $(".js-user-toggle");

function showNav() {
	menu.addClass('menu-open');
	$("body").addClass('nav-open');
	window.setTimeout(function () { $('body').addClass('no-scroll'); }, 200); // Firefox hack. Hides scrollbar as soon as menu animation is done
	$('.nav--main a').attr('tabindex', ''); // links inside navigation should be TAB selectable
}

function hideNav() {
	menu.removeClass('menu-open');
	$("body").removeClass('nav-open');
	window.setTimeout(function () { $('body').removeClass('no-scroll'); }, 10); // allow animations to start before removing class (Firefox)
	$('.nav--main a').attr('tabindex', '-1'); // links inside hidden navigation should not be TAB selectable
}

function showHideNav() {
	if ($(".js-menu").hasClass('menu-open')) {
		hideNav();
	} else {
		showNav();
	}
}

// Shows/hides navigation’s popover if class "expanded"
toggle.on('click touchstart', function (event) {
	showHideNav();
	event.preventDefault();
});

$(".menu-item-arrow").on('click touchstart', function (event) {
	var width = $(window).width();
	if (width < 1024) {
		event.preventDefault();
		$(this).parent().parent().toggleClass("submenu-open");
	}
});

userToggle.on("click touchstart", function() {
	if ($(".header-partners__user-menu").hasClass('menu-open')) {
		$(".header-partners__user-menu").removeClass('menu-open');
		$(".header-partners__user-menu").fadeOut(200);
	} else {
		$(".header-partners__user-menu").addClass('menu-open');
		$(".header-partners__user-menu").fadeIn(200);
	}
});

function hideModalSearch() {
	// $("main").attr("aria-hidden", "false");
	// $(".modal-searchform").fadeOut(200);
	// $(".modal-searchform").attr("aria-hidden", "true");
	// $(".modal-searchform").removeClass("modal-open");
	// $(".modal-searchform").removeClass("keyboard-init");
	$(".header-main__search").removeClass("header-main__search--open");
	window.setTimeout(function () { $('body').removeClass('no-scroll'); }, 10);

}

function hideModalCategories() {
	$("main").attr("aria-hidden", "false");
	$(".modal-categories").fadeOut(200);
	$(".modal-categories").attr("aria-hidden", "true");
	$(".modal-categories").removeClass("modal-open");
	$(".modal-categories").removeClass("keyboard-init");
	window.setTimeout(function () { $('body').removeClass('no-scroll'); }, 10);
}

function hideModalPartnersSearch() {
	$("main").attr("aria-hidden", "false");
	$(".modal-partners-searchform").fadeOut(200);
	$(".modal-partners-searchform").attr("aria-hidden", "true");
	$(".modal-partners-searchform").removeClass("modal-open");
	$(".modal-partners-searchform").removeClass("keyboard-init");
	window.setTimeout(function () { $('body').removeClass('no-scroll'); }, 10);
}

function hideModalCallToAction() {
	$("main").attr("aria-hidden", "false");
	$(".modal-cta").fadeOut(200);
	$(".modal-cta").attr("aria-hidden", "true");
	$(".modal-cta").removeClass("modal-open");
	$(".modal-cta").removeClass("keyboard-init");
	window.setTimeout(function () { $('body').removeClass('no-scroll'); }, 10);
}

// Search
searchToggle.on('click touchstart', function (event) {
	// event.preventDefault();
	// $("main").attr("aria-hidden", "true");
	// $(".modal-searchform").fadeIn(200);
	// $(".modal-searchform").attr("aria-hidden", "false");
	// $(".modal-searchform").addClass("modal-open");
	// $(".modal-searchform .searchform #s").focus();
	var $search = $(".header-main__search");
	var $input = $search.find('input[type="search"]');
	window.setTimeout(function () { $('body').addClass('no-scroll'); }, 200);
	$(".header-main__search").addClass("header-main__search--open");
	setTimeout(function () {
		$input.focus();
	}, 10);
	event.stopPropagation();
});

// searchToggle.keydown(function(event) {
// 	if (event.keyCode == 13) {
// 		$(".modal-searchform").addClass("keyboard-init");
// 	}
// });

// $(".close-searchform").on("click touchstart", function(event) {
// 	event.preventDefault();
// 	hideModalSearch();
// });

$(".header-main__search-close").on("click touchstart", function(event) {
	event.preventDefault();
	hideModalSearch();
});

// Topics
topicsToggle.on('click touchstart', function (event) {
	event.preventDefault();
	$("main").attr("aria-hidden", "true");
	$(".modal-categories").fadeIn(200);
	$(".modal-categories").attr("aria-hidden", "false");
	$(".modal-categories").addClass("modal-open");
	window.setTimeout(function () { $('body').addClass('no-scroll'); }, 200);
});

topicsToggle.keydown(function(event) {
	if (event.keyCode == 13) {
		$(".modal-categories").addClass("keyboard-init");
	}
});

$(".close-categories").on("click touchstart", function(event) {
	event.preventDefault();
	hideModalCategories();
});

// Partners Search
partnersSearchToggle.on('click touchstart', function (event) {
	event.preventDefault();
	$("main").attr("aria-hidden", "true");
	$(".modal-partners-searchform").fadeIn(200);
	$(".modal-partners-searchform").attr("aria-hidden", "false");
	$(".modal-partners-searchform").addClass("modal-open");
	$(".modal-partners-searchform .searchform #s").focus();
	window.setTimeout(function () { $('body').addClass('no-scroll'); }, 200);
});

partnersSearchToggle.keydown(function(event) {
	if (event.keyCode == 13) {
		$(".modal-partners-searchform").addClass("keyboard-init");
	}
});

$(".close-partners-searchform").on("click touchstart", function(event) {
	event.preventDefault();
	hideModalPartnersSearch();
});

// Call to Action
ctaToggle.on('click touchstart', function (event) {
	event.preventDefault();
	$("main").attr("aria-hidden", "true");
	$(".modal-cta").fadeIn(200);
	$(".modal-cta").attr("aria-hidden", "false");
	$(".modal-cta").addClass("modal-open");
	window.setTimeout(function () { $('body').addClass('no-scroll'); }, 200);
});

ctaToggle.keydown(function(event) {
	if (event.keyCode == 13) {
		$(".modal-cta").addClass("keyboard-init");
	}
});

$(".close-cta").on("click touchstart", function(event) {
	event.preventDefault();
	hideModalCallToAction();
});

$(document).keydown(function(event) { 
	if (event.keyCode == 27) { 
		// if ($(".modal-searchform").hasClass("modal-open")) {
		// 	hideModalSearch();
		// }
		if ($(".header-main__search").hasClass("header-main__search--open")) {
			hideModalSearch();
		}
		if ($(".modal-categories").hasClass("modal-open")) {
			hideModalCategories();
		}
		if ($(".modal-partners-searchform").hasClass("modal-open")) {
			hideModalPartnersSearch();
		}
		if ($(".modal-cta").hasClass("modal-open")) {
			hideModalCallToAction();
		}
	}
});

$(document).on('click', function (event) {
	var $search = $(".header-main__search");

	if ($search.hasClass("header-main__search--open")) {
		if (!$(event.target).closest(".header-main__search").length) {
			hideModalSearch();
		}
	}
});

document.addEventListener('DOMContentLoaded', function () {
	/*** Mega Menu ***/
	const headerMain = document.getElementById("header-main");

	if (headerMain) {
		const menuItems = document.querySelectorAll(".header-main__nav.nav > .nav__menu > .menu-item.menu-item-has-children");
		const megaPanels = document.querySelectorAll(".mega-menu__panel");

		const mediaQuery = window.matchMedia("(min-width: 1024px)");

		let closeTimer;
		let enabled = false;

		function openMenu(name) {
			clearTimeout(closeTimer);

			headerMain.classList.add("header-main--mega-open");

			let activePanel = null;

			megaPanels.forEach(panel => {
				if (panel.dataset.panel === name) {
					panel.classList.add("mega-menu__panel--active");
					activePanel = panel;
				} else {
					panel.classList.remove("mega-menu__panel--active");
				}
			});

			if (activePanel) {
				const panelsContainer = document.querySelector(".mega-menu__panels");

				// measure height
				const height = activePanel.offsetHeight;

				panelsContainer.style.height = height + "px";
			}
		}

		function closeMenu() {
			closeTimer = setTimeout(() => {
				headerMain.classList.remove("header-main--mega-open");

				megaPanels.forEach(p => p.classList.remove("mega-menu__panel--active"));

				const panelsContainer = document.querySelector(".mega-menu__panels");
				panelsContainer.style.height = "0px";

				setActiveMenuItem(null);
			}, 200);
		}

		function enableMenu() {
			if (enabled) return;
			enabled = true;

			menuItems.forEach(item => {
				item.addEventListener("mouseenter", handleEnter);
			});

			headerMain.addEventListener("mouseenter", handleHeaderEnter);
			headerMain.addEventListener("mouseleave", handleHeaderLeave);
		}

		function disableMenu() {
			if (!enabled) return;
			enabled = false;

			menuItems.forEach(item => {
				item.removeEventListener("mouseenter", handleEnter);
			});

			headerMain.removeEventListener("mouseenter", handleHeaderEnter);
			headerMain.removeEventListener("mouseleave", handleHeaderLeave);

			headerMain.classList.remove("header-main--mega-open");
			megaPanels.forEach(p => p.classList.remove("mega-menu__panel--active"));
		}

		function handleEnter(e) {
			// openMenu(e.currentTarget.dataset.menu);
			const item = e.currentTarget;
			setActiveMenuItem(item);
			openMenu(item.dataset.menu);
		}

		function handleHeaderEnter() {
			clearTimeout(closeTimer);
		}

		function handleHeaderLeave() {
			closeMenu();
		}

		function setActiveMenuItem(activeItem) {
			menuItems.forEach(item => {
				item.classList.remove("menu-item-has-children--expanded");
			});

			if (activeItem) {
				activeItem.classList.add("menu-item-has-children--expanded");
			}
		}

		function checkBreakpoint(e) {
			if (e.matches) {
				enableMenu();
			} else {
				disableMenu();
			}
		}

		checkBreakpoint(mediaQuery);
		mediaQuery.addEventListener("change", checkBreakpoint);
	}

	/*** Partner Posts Filter ***/
  const partnerNav = document.querySelector(".main-partners__nav-container .nav__menu");
  const partnerButton = document.querySelector(".main-partners__tags-toggle");
	const partnerPosts = document.querySelector(".main-partners__tease-container");

  if (partnerNav && partnerButton) {
    let expanded = false;
    let resizeTimeout;

		partnerNav.style.maxHeight = "none";

    function getFirstRowHeight() {
      const clone = partnerNav.cloneNode(true);

      clone.style.visibility = "hidden";
      clone.style.position = "absolute";
      clone.style.pointerEvents = "none";
      clone.style.maxHeight = "none";
      clone.style.width = partnerNav.offsetWidth + "px";

      document.body.appendChild(clone);

      const items = clone.querySelectorAll("li");
      const firstTop = items[0].offsetTop;

      items.forEach(item => {
        if (item.offsetTop > firstTop) {
          item.remove();
        }
      });

      const height = clone.scrollHeight;

      document.body.removeChild(clone);

      return height;
    }

    function checkIfOverflowing() {
      const firstRowHeight = getFirstRowHeight();
      const fullHeight = partnerNav.scrollHeight;

      if (fullHeight <= firstRowHeight + 1) {
        partnerButton.style.display = "none";
        partnerNav.style.maxHeight = "none";
        return false;
      } else {
        partnerButton.style.display = "";
        return true;
      }
    }

    function update() {
      const hasOverflow = checkIfOverflowing();
      if (!hasOverflow) return;

      if (expanded) {
        partnerNav.style.maxHeight = partnerNav.scrollHeight + "px";
      } else {
        partnerNav.style.maxHeight = getFirstRowHeight() + "px";
      }
    }

    partnerButton.addEventListener("click", () => {
      expanded = !expanded;

      partnerNav.classList.toggle("is-expanded", expanded);
      partnerButton.querySelector("span").textContent = expanded ? "Less" : "More";
      partnerButton.setAttribute("aria-expanded", expanded);

      if (expanded) {
        partnerNav.style.maxHeight = partnerNav.offsetHeight + "px";
        partnerNav.offsetHeight;
        partnerNav.style.maxHeight = partnerNav.scrollHeight + "px";
      } else {
        partnerNav.style.maxHeight = getFirstRowHeight() + "px";
      }
    });

    update();

    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(update, 100);
    });

    if (document.fonts) {
      document.fonts.ready.then(update);
    }

		if (partnerPosts) {
			const activeFilters = new Set();
			const filters = partnerNav.querySelectorAll("button");
			const currentContainer = document.querySelector(".main-partners__current-container");
			const currentFilters = document.querySelector(".main-partners__current");
			const posts = partnerPosts.querySelectorAll(".tease");

			function renderActiveFilters() {
				if (activeFilters.size === 0) {
					currentContainer.classList.remove("main-partners__current-container--active");
					currentFilters.innerHTML = "";
					return;
				}

				currentContainer.classList.add("main-partners__current-container--active");
				currentFilters.innerHTML = "";

				activeFilters.forEach(tag => {
					const btn = document.createElement("button");
					btn.className = "pill pill--active";
					const span = document.createElement("span");
					const close = document.createElement("div");

					// get the human-readable name from the original button
					const original = partnerNav.querySelector(`[data-tag="${tag}"]`);
					const name = original ? original.dataset.name : tag;

					span.textContent = name;
					btn.appendChild(span);
					close.innerHTML = "<svg width='11' height='11' viewBox='0 0 11 11' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M10.3125 0.707031L5.86328 5.15625L10.3125 9.60547L9.60547 10.3125L5.15625 5.86328L0.707031 10.3125L0 9.60547L4.44922 5.15625L0 0.707031L0.707031 0L5.15625 4.44922L9.60547 0L10.3125 0.707031Z' fill='#EB088A'/></svg>"
					btn.appendChild(close);

					btn.addEventListener("click", () => {
						activeFilters.delete(tag);

						// un-highlight original button
						const original = partnerNav.querySelector(`[data-tag="${tag}"]`);
						if (original) original.classList.remove("is-active");

						updatePosts();
						renderActiveFilters();
					});

					currentFilters.appendChild(btn);
				});
			}

			function updatePosts() {
				posts.forEach(post => {
					const postTags = post.dataset.tags.split(" ");

					const match =
						activeFilters.size === 0 ||
						// [...activeFilters].some(tag => postTags.includes(tag)); // OR Logic
						[...activeFilters].every(tag => postTags.includes(tag)); // AND Logic

					if (match) {
						post.style.display = "block";
						setTimeout(() => (post.style.opacity = 1), 50);
					} else {
						post.style.opacity = 0;
						setTimeout(() => (post.style.display = "none"), 300);
					}
				});
			}

			// function updatePosts() {
			// 	posts.forEach(post => {
			// 		const postTags = post.dataset.tags.split(" ");

			// 		const match =
			// 			activeFilters.size === 0 ||
			// 			[...activeFilters].every(tag => postTags.includes(tag)); // AND Logic

			// 		if (match) {
			// 			// show post
			// 			post.classList.remove("is-hidden");

			// 			// allow reflow so transition works
			// 			requestAnimationFrame(() => {
			// 				post.classList.remove("is-hiding");
			// 			});

			// 		} else {
			// 			// start animation
			// 			post.classList.add("is-hiding");

			// 			// after animation ends, remove from layout
			// 			setTimeout(() => {
			// 				post.classList.add("is-hidden");
			// 			}, 300); // match CSS duration
			// 		}
			// 	});
			// }

			filters.forEach(button => {
				button.addEventListener("click", function (e) {
					e.preventDefault();

					const tag = this.dataset.tag;

					// toggle tag in Set
					if (activeFilters.has(tag)) {
						activeFilters.delete(tag);
						this.classList.remove("is-active");
					} else {
						activeFilters.add(tag);
						this.classList.add("is-active");
					}

					updatePosts();
					renderActiveFilters();
				});
			});
		}
  }


	/*** Related Posts Carousel ***/
  const carousel = document.querySelector('.related-posts--carousel');
  if (!carousel) return;

  const container = carousel.querySelector('.related-posts__container');
  const slides = carousel.querySelectorAll('.tease');
  const prevBtn = carousel.querySelector('.related-posts__prev');
  const nextBtn = carousel.querySelector('.related-posts__next');

  let currentIndex = 0;
  let slidesPerView = 1;

  function getSlidesPerView() {
    if (window.innerWidth >= 1024) return 3;
    if (window.innerWidth >= 768) return 2.5;
    return 1.5;
  }

  function getGap() {
    const styles = window.getComputedStyle(container);
    return parseInt(styles.columnGap) || 0;
  }

  function getSlideWidth() {
    return slides[0].offsetWidth + getGap();
  }

  function getMaxIndex() {
    return Math.ceil(slides.length - slidesPerView);
  }

  function updateButtons() {
    const maxIndex = getMaxIndex();

    if (currentIndex <= 0) {
      prevBtn.classList.add('related-posts__button--disabled');
      prevBtn.setAttribute('disabled', true);
    } else {
      prevBtn.classList.remove('related-posts__button--disabled');
      prevBtn.removeAttribute('disabled');
    }

    if (currentIndex >= maxIndex) {
      nextBtn.classList.add('related-posts__button--disabled');
      nextBtn.setAttribute('disabled', true);
    } else {
      nextBtn.classList.remove('related-posts__button--disabled');
      nextBtn.removeAttribute('disabled');
    }
  }

  function updateCarousel() {
    slidesPerView = getSlidesPerView();

    const maxIndex = getMaxIndex();
    if (currentIndex > maxIndex) {
      currentIndex = Math.max(maxIndex, 0);
    }

    const slideWidth = getSlideWidth();
    container.style.transform = `translateX(-${currentIndex * slideWidth}px)`;

    updateButtons();
  }

  nextBtn.addEventListener('click', function () {
    if (currentIndex < getMaxIndex()) {
      currentIndex++;
      updateCarousel();
    }
  });

  prevBtn.addEventListener('click', function () {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  });

  window.addEventListener('resize', updateCarousel);

  updateCarousel();
});

/*** Fluid Gradient ***/
const VERT = `
attribute vec2 a_pos;
varying vec2 vUv;
void main() {
  vUv = a_pos * 0.5 + 0.5;
  gl_Position = vec4(a_pos, 0.0, 1.0);
}`;

const FRAG = `
precision mediump float;
uniform float u_time;
uniform vec2  u_res;
uniform vec3  u_colorA;
uniform vec3  u_colorB;
uniform vec2  u_offset;
varying vec2  vUv;

float hash(vec2 p) {
  p = fract(p * vec2(234.34, 435.345));
  p += dot(p, p + 34.23);
  return fract(p.x * p.y);
}

float noise(vec2 p) {
  vec2 i = floor(p);
  vec2 f = fract(p);
  vec2 u = f * f * (3.0 - 2.0 * f);
  return mix(
    mix(hash(i),               hash(i + vec2(1.0, 0.0)), u.x),
    mix(hash(i + vec2(0.0,1.0)), hash(i + vec2(1.0,1.0)), u.x),
    u.y
  );
}

float fbm(vec2 p) {
  float v = 0.0, a = 0.5;
  for (int i = 0; i < 4; i++) {
    v += a * noise(p);
    p  = p * 2.0 + vec2(3.1, 1.7);
    a *= 0.5;
  }
  return v;
}

float domainWarp(vec2 p, vec2 ct) {
  vec2 q = vec2(
    fbm(p + ct * 0.8),
    fbm(p + ct.yx * 0.6 + vec2(5.2, 1.3))
  );
  vec2 r = vec2(
    fbm(p + 3.0 * q + ct * 0.5 + vec2(1.7, 9.2)),
    fbm(p + 3.0 * q + ct.yx * 0.4 + vec2(8.3, 2.8))
  );
  return fbm(p + 3.5 * r + ct * 0.3);
}

void main() {
  float angle = mod(u_time, 108.0) / 108.0 * 6.28318;
  vec2 ct = vec2(cos(angle), sin(angle)) * 0.5;
  // Flow field: spatially-varying rotation from low-freq noise
  vec2 p  = vUv * 0.5 + u_offset;

  float t = domainWarp(p, ct);
  vec3 color = mix(u_colorA, u_colorB, smoothstep(0.1, 0.6, t));
  color *= 1.12;

  float timeSeed = fract(floor(u_time * 15.0) * 0.7539);
  float g = hash(floor(vUv * u_res * 0.24) + timeSeed);
  color += (g - 0.5) * 0.0375;

  gl_FragColor = vec4(clamp(color, 0.0, 1.0), 1.0);
}`;

function hexToRgb(hex) {
	const n = parseInt(hex.replace('#', ''), 16);
	return [(n >> 16 & 255) / 255, (n >> 8 & 255) / 255, (n & 255) / 255];
}

function compile(gl, type, src) {
	const s = gl.createShader(type);
	gl.shaderSource(s, src);
	gl.compileShader(s);
	if (!gl.getShaderParameter(s, gl.COMPILE_STATUS))
		console.error('FluidGradient shader error:', gl.getShaderInfoLog(s));
	return s;
}

function initInstance(el) {
	// Container must establish a positioning context
	if (getComputedStyle(el).position === 'static') el.style.position = 'relative';

	const canvas = document.createElement('canvas');
	canvas.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;display:block;';
	el.appendChild(canvas);

	const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
	if (!gl) { console.warn('FluidGradient: WebGL not supported'); return; }

	const prog = gl.createProgram();
	gl.attachShader(prog, compile(gl, gl.VERTEX_SHADER,   VERT));
	gl.attachShader(prog, compile(gl, gl.FRAGMENT_SHADER, FRAG));
	gl.linkProgram(prog);
	gl.useProgram(prog);

	const buf = gl.createBuffer();
	gl.bindBuffer(gl.ARRAY_BUFFER, buf);
	gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 1,-1, -1,1, 1,1]), gl.STATIC_DRAW);
	const aPos = gl.getAttribLocation(prog, 'a_pos');
	gl.enableVertexAttribArray(aPos);
	gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0);

	const uTime   = gl.getUniformLocation(prog, 'u_time');
	const uRes    = gl.getUniformLocation(prog, 'u_res');
	const uColorA  = gl.getUniformLocation(prog, 'u_colorA');
	const uColorB  = gl.getUniformLocation(prog, 'u_colorB');
	const uOffset  = gl.getUniformLocation(prog, 'u_offset');

	gl.uniform3fv(uColorA, hexToRgb(el.dataset.colorA || '#EB088A'));
	gl.uniform3fv(uColorB, hexToRgb(el.dataset.colorB || '#313cff'));
	gl.uniform2f(uOffset, Math.random() * 100, Math.random() * 100);

	function resize() {
		const dpr = Math.min(window.devicePixelRatio || 1, 2);
		canvas.width  = el.offsetWidth  * dpr;
		canvas.height = el.offsetHeight * dpr;
		gl.viewport(0, 0, canvas.width, canvas.height);
	}

	const ro = new ResizeObserver(resize);
	ro.observe(el);
	resize();

	let startTime = null;
	(function render(ts) {
		if (!startTime) startTime = ts;
		gl.uniform1f(uTime, (ts - startTime) / 1000);
		gl.uniform2f(uRes, canvas.width, canvas.height);
		gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
		requestAnimationFrame(render);
	})(performance.now());
}

function init(el) { initInstance(el); }

// Auto-init on DOM ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', function () {
		document.querySelectorAll('.fluid-gradient').forEach(initInstance);
	});
} else {
	document.querySelectorAll('.fluid-gradient').forEach(initInstance);
}

window.FluidGradient = { init };